import React from 'react';
import ExpenseResolutionType1Workspace from './ExpenseResolutionType1Workspace';

/** 지출결의등록(type1) — 채주 + 사업·다과목 → 1결의 */
export default function ExpenseResolutionRegisterType1() {
  return <ExpenseResolutionType1Workspace />;
}
